export default __webpack_public_path__ + "static/media/echope-footer.44dca185.png";